<template>
  <input
    ref="date" :value="modelValue" type="text" class="form-control" maxlength="10"
    pattern="([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}"
  >
</template>

<script>
import IMask from 'imask';

export default {
  props: {
    modelValue: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data: () => ({ instance: null }),
  mounted() {
    this.instance = IMask(this.$refs.date, { mask: '00/00/0000' });
    this.instance.on('accept', () => this.$emit('update:modelValue', this.$refs.date.value));
  },
  unmounted() { this.instance.destroy(); },
};
</script>
